<template>
    <router-view />
</template>

<script>
import LoginService from '@/service/LoginService';
import http from '@/plugins/axios/axios';
import { CHAVE_USUARIO, CHVAE_TOKEN } from '@/global';
import { mapActions } from 'vuex';

export default {  
    loginService: null,    
    methods: {     
        ...mapActions('sessao', ['criarSessao']), 
        async validarToken() {                  
            let token = JSON.parse(sessionStorage.getItem(CHVAE_TOKEN));             
            if(!token) {                                          
                return   
            }             
            let dadosUsuario = JSON.parse(sessionStorage.getItem(CHAVE_USUARIO));         
            let usuario = dadosUsuario.requisicao.usuario;
            let usuarioValidaToken = {
                id: usuario.id,
                email: usuario.email,
                token: token.valor
            }            
            // Validando o token
            const resp = await this.loginService.validarToken(usuarioValidaToken);               
            // Token válido. Atualizar!
            if(resp.data.tokenValido) {                  
                dadosUsuario.token = resp.data.token;
                // Header do axios
                http.defaults.headers.common['Authorization'] = 'Bearer '+resp.data.token.valor;               
                this.criarSessao(dadosUsuario);               
            } else { // Inválido! Login!                
                sessionStorage.clear(); 
                this.$router.push({ path: '/login' });      
            } 
        },        
    },
    created() {
        this.loginService = new LoginService();
    }
}
</script>

<style>
</style>